module.exports = __webpack_public_path__ + "img/blueprint-background.d0d2e050.png";